import type { InitialConfig, ShippingsResponse } from "@src/types";
import type { MetaZipCodeContext } from "@meta/types";
import { metaAdapter } from "@meta/index"
import { getShippingTier, getDeliveryTime } from "./utils";
import type { PickupFlagPickupContext, PickupShippingsContext, PickupBrandContext } from "./types";

export const pickupAdapter = {

  ...metaAdapter,

  flag_pickup: (context: PickupFlagPickupContext): boolean | null => {
    return context?.flag_pickup ?? null;
  },

  shippings: (context: PickupShippingsContext): ShippingsResponse[] | null => {
    if (context.shippings) {
      return context.shippings.map((s) => ({
        line_items: s.line_items ?? '',
        shipping: s.price / 100,
        shipping_tier: getShippingTier(s),
        delivery_time: getDeliveryTime(s),
      }))
    }

    return null;
  },

  brand: (context: PickupBrandContext, config: InitialConfig): string | null => {
    if (config?.brand) return config.brand
    if (context?.brand) return context.brand

    return null
  },

  zipcode: (context: MetaZipCodeContext) => {
    return context.meta.zipcode ?? null;
  },
}